import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout/Layout'
// Core
import TypographyPage from '@/pages/Core/Typography/Typography'
import ColorsPage from '@/pages/Core/Colors/Colors'
import CoreGridPage from '@/pages/Core/Grid/Grid'
// Tables
import TablesBasicPage from '@/pages/Tables/Basic/Basic'
import TablesDynamicPage from '@/pages/Tables/Dynamic/Dynamic'
// Maps
import GoogleMapPage from '@/pages/Maps/Google/Google'
import AmchartsMapPage from '@/pages/Maps/Amcharts/Amcharts'
// Main
import VisitsPage from '@/pages/Visits/Visits'
import AnalyticsPage from '@/pages/Dashboard/IndexDashboard'
import WidgetsPage from '@/pages/Widgets/Widgets'
// Charts
import ChartsPage from '@/pages/Charts/Charts'
import ApexPage from '@/pages/Charts/Apex/Apex'
import EchartsPage from '@/pages/Charts/Echarts/Echarts'
import HighchartsPage from '@/pages/Charts/Highcharts/Highcharts'

import ProfilePage from '@/pages/Profile/Profile'
// Profile
import PackagePage from '@/pages/Package/Package'
// Chat
import ChatPage from '@/pages/Chat/Chat'
// Email
import EmailPage from '@/pages/Email/Email'
// Ecommerce
import ProductsManagement from '@/pages/Ecommerce/Management/Management'
import ProductEdit from '@/pages/Ecommerce/Management/components/ProductEdit/ProductEdit'
import ProductsPage from '@/pages/Ecommerce/ProductsGrid/ProductsGrid'
import ProductPage from '@/pages/Ecommerce/ProductPage/ProductPage'
// Grid
import GridPagePage from '@/pages/Grid/Grid'
// Forms
import FormElementsPage from '@/pages/Forms/Elements/Elements'
import FormValidationPage from '@/pages/Forms/Validation/Validation'
import FormWizardPage from '@/pages/Forms/Wizard/Wizard'
// Extra
import CalendarPage from '@/pages/Extra/Calendar/Calendar'
import InvoicePage from '@/pages/Extra/Invoice/Invoice'
import SearchPage from '@/pages/Extra/Search/Search'
import TimelinePage from '@/pages/Extra/Timeline/Timeline'
import GalleryPage from '@/pages/Extra/Gallery/Gallery'
import Login from '@/pages/Login/Login'
import VerifikasiUser from '@/pages/Login/VerifikasiUser/VerifikasiUser'
import LoginExample from '@/pages/Extra/LoginExample/LoginExample'
import Register from '@/pages/Register/Register'
import ErrorPage from '@/pages/Error/Error'
import LupaPassword from '@/pages/Login/LupaPassword'
// Ui
import AlertsPage from '@/pages/Ui/Alerts/Alerts'
import BadgePage from '@/pages/Ui/Badge/Badge'
import ButtonsPage from '@/pages/Ui/Buttons/Buttons'
import CardPage from '@/pages/Ui/Card/Card'
import CarouselPage from '@/pages/Ui/Carousel/Carousel'
import IconsPage from '@/pages/Ui/Icons/Icons'
import JumbotronPage from '@/pages/Ui/Jumbotron/Jumbotron'
import ListGroupsPage from '@/pages/Ui/ListGroups/ListGroups'
import ModalPage from '@/pages/Ui/Modal/Modal'
import NavPage from '@/pages/Ui/Nav/Nav'
import NavbarPage from '@/pages/Ui/Navbar/Navbar'
import NotificationsPage from '@/pages/Ui/Notifications/Notifications'
import PopoversPage from '@/pages/Ui/Popovers/Popovers'
import ProgressPage from '@/pages/Ui/Progress/Progress'
import TabsPage from '@/pages/Ui/Tabs/Tabs'

import Documentation from '@/documentation/DocumentationLayout'
import DocLicensesPage from '@/documentation/pages/getting-started/Licenses'
import DocQuickStartPage from '@/documentation/pages/getting-started/QuickStart'
import DocOverviewPage from '@/documentation/pages/getting-started/Overview'
import DocLibsPage from '@/documentation/pages/Libs'
import DocPagesPage from '@/documentation/pages/Pages'
import DocAlertsPage from '@/documentation/pages/components/Alerts'
import DocBadgePage from '@/documentation/pages/components/Badge'
import DocButtonsPage from '@/documentation/pages/components/Buttons'
import DocCardPage from '@/documentation/pages/components/Card'
import DocCarouselPage from '@/documentation/pages/components/Carousel'
import DocModalPage from '@/documentation/pages/components/Modal'
import DocNavPage from '@/documentation/pages/components/Nav'
import DocNavbarPage from '@/documentation/pages/components/Navbar'
import DocPopoversPage from '@/documentation/pages/components/Popovers'
import DocProgressPage from '@/documentation/pages/components/Progress'
import DocTabsPage from '@/documentation/pages/components/Tabs'

// User
import UserPage from '@/pages/User/User'
// Role
import RolePage from '@/pages/Role/Role'

// ToS
import TOS from '@/pages/tos/tos'

// Jenis Proyek
import JenisPage from '@/pages/Master/JenisProyek/JenisProyek'
import RisikoPage from '@/pages/Master/Risiko/Risiko'
import SkalaPage from '@/pages/Master/SkalaUsaha/SkalaUsaha'
import StatusPage from '@/pages/Master/StatusVerifikasi/StatusVerifikasi'
import LokasiPage from '@/pages/Master/Lokasi/Lokasi'
import JenisPermohonanPage from '@/pages/Master/JenisPermohonan/JenisPermohonan'
import KlasifikasiPemohonPage from '@/pages/Master/KlasifikasiPemohon/KlasifikasiPemohon'
import TandatanganPage from '@/pages/Master/Tandatangan/Tandatangan'
import KBLIPage from '@/pages/Master/KBLI/KBLI'
import PEMDA from '@/pages/Master/Pemda/Pemda'
import Kementerian from '@/pages/Master/Kementerian/Kementerian'
import KopSurat from '@/pages/Master/KopSurat/KopSurat'
import CapaianTargetPNBP from '@/pages/Master/CapaianTargetPNBP/CapaianTargetPNBP'

// Periznan
import PerizinanDokumenPage from '@/pages/Perizinan/Dokumen/Dokumen'
import PerizinanDetailPage from '@/pages/Perizinan/Dokumen/Detail/Detail'
import PerizinanDokumenDetailPage from '@/pages/Perizinan/Dokumen/Verdok/Verdok'
import PerizinanTeknisDetailPage from '@/pages/Perizinan/Dokumen/Vertek/Vertek'
import PerizinanBADetailPage from '@/pages/Perizinan/Dokumen/BA/BA'

//UMK
import PerizinanUMK from '@/pages/Perizinan/UMK/PermohonanUMK'
import PerizinanDetailUMK from '@/pages/Perizinan/UMK/Detail/Detail'

// Non Berusaha
import NonberusahaPemerintah from '@/pages/Perizinan/Nonberusaha/PermohonanPemerintah'
import NonberusahaSwasta from '@/pages/Perizinan/Nonberusaha/PermohonanSwasta'
import FormPermohonanNonberusaha from '@/pages/Perizinan/Nonberusaha/formPermohonan'
import VerdokNonBerusaha from '@/pages/Perizinan/Nonberusaha/Verdok/Verdok'
import PentekNonberusaha from '@/pages/Perizinan/Nonberusaha/Vertek/Vertek'
import BANonBerusaha from '@/pages/Perizinan/Nonberusaha/BA/BA'
import PerizinanNonberusaha from '@/pages/Perizinan/Nonberusaha/Detail/Detail'

// Notifikasi Izin Lokasi
import IzinLokasiDokumenPage from '@/pages/Perizinan/IzinLokasi/IzinLokasi'
import IzinLokasiDetailPage from '@/pages/Perizinan/IzinLokasi/Detail/Detail'
import IzinLokasiDokumenDetailPage from '@/pages/Perizinan/IzinLokasi/Verdok/Verdok'
import IzinLokasiTeknisDetailPage from '@/pages/Perizinan/IzinLokasi/Vertek/Vertek'
import IzinLokasiBADetailPage from '@/pages/Perizinan/IzinLokasi/BA/BA'

//Penambahan KBLI
import PenambahanKBLIDokumenPage from '@/pages/Perizinan/PenambahanKBLI/Dokumen'
import PenambahanKBLIDetailPage from '@/pages/Perizinan/PenambahanKBLI/Detail/Detail'
import PenambahanKBLIDokumenDetailPage from '@/pages/Perizinan/PenambahanKBLI/Verdok/Verdok'
import PenambahanKBLITeknisDetailPage from '@/pages/Perizinan/PenambahanKBLI/Vertek/Vertek'
import PenambahanKBLIBADetailPage from '@/pages/Perizinan/PenambahanKBLI/BA/BA'

import PermohonanBerusaha from '@/pages/Permohonan/PermohonanBerusaha'
import PermohonanPemerintah from '@/pages/Permohonan/PermohonanPemerintah'
import FormPermohonan from '@/pages/Permohonan/formPermohonan'
import DetailPermohonan from '@/pages/Permohonan/DetailPermohonan'
import FormPermohonanBerusaha from '@/pages/Permohonan/formPermohonanBerusaha'
import PermohonanSwasta from '@/pages/Permohonan/PermohonanSwasta'
import FormPermohonanUMK from '@/pages/Permohonan/formPermohonanUMK'
import PermohonanUMK from '@/pages/Permohonan/PermohonanUMK'

// Pengendalian
import DashboardPengendalian from '@/pages/Dashboard/DashboardPengendalian.vue'
import LaporanTahunanPage from '@/pages/LaporanTahunan/LaporanTahunanMaintenance.vue'
import formLaporanTahunanPage from '@/pages/LaporanTahunan/formLaporanTahunan'
import PenilaianLaporanTahunanPage from '@/pages/PenilaianLaporanTahunan/PenilaianLaporanTahunan'
import formVerifikasiLaporanPage from '@/pages/PenilaianLaporanTahunan/formVerifikasiLaporan'

// Pemutakhiran
import Pemutakhiran from './pages/Pemutakhiran/Pemutakhiran/Pemutakhiran.vue'
import PemutakhiranForm from './pages/Pemutakhiran/Pemutakhiran/PemutakhiranForm.vue'
import EarlyWarningBerusaha from './pages/Pemutakhiran/EarlyWarning/Berusaha.vue'
import EarlyWarningPemerintah from './pages/Pemutakhiran/EarlyWarning/Pemerintah.vue'
import EarlyWarningSwasta from './pages/Pemutakhiran/EarlyWarning/Swasta.vue'
import HabisMasaBerlaku from './pages/Pemutakhiran/HabisMasaBerlaku/HabisMasaBerlaku.vue'
import HabisMasaBerlakuPemutakhiran from './pages/Pemutakhiran/HabisMasaBerlaku/Pemutakhiran/FormPemutakhiran.vue'
import Perubahan from './pages/Pemutakhiran/Perubahan/Perubahan.vue'
import PerubahanVerifikasi from './pages/Pemutakhiran/Perubahan/Verifikasi/FormVerifikasi.vue'
import PerubahanPemutakhiran from './pages/Pemutakhiran/Perubahan/Pemutakhiran/FormPemutakhiran.vue'
import Pembatalan from './pages/Pemutakhiran/Pembatalan/Pembatalan.vue'
import PembatalanVerifikasi from './pages/Pemutakhiran/Pembatalan/Verifikasi/FormVerifikasi.vue'
import PembatalanPemutakhiran from './pages/Pemutakhiran/Pembatalan/Pemutakhiran/FormPemutakhiran.vue'
import Pencabutan from './pages/Pemutakhiran/Pencabutan/Pencabutan.vue'
import PencabutanPemutakhiran from './pages/Pemutakhiran/Pencabutan/Pemutakhiran/FormPemutakhiran.vue'

import PanduanPage from '@/pages/Panduan/Panduan'

import { isAuthenticated } from './mixins/auth'

// Web ProfilPagee
import Profile from '@/pages/WebProfile/Profile/profile'
import Slider from '@/pages/WebProfile/Slider/slider'
import Approval from '@/pages/WebProfile/Approval/approval'
import About from '@/pages/WebProfile/About/about'
import Announcement from '@/pages/WebProfile/Announcement/announcement'
import AnnouncementDetail from '@/pages/WebProfile/Announcement/AnnouncementDetail'
import Report from '@/pages/WebProfile/Report/report'
import Gallery from '@/pages/WebProfile/Gallery/gallery'
import faq from '@/pages/WebProfile/Faq/faq'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    { path: '/', redirect: '/app/dashboard' },
    { path: '/app', redirect: '/app/dashboard' },
    { 
      path: '/pengendalian', 
      beforeEnter() {
        window.location.replace('https://app-sea.kkp.go.id/pengendalian/')
      }
    },
    // {path: '/app/dashboard', redirect: '/app/dashboard'},
    { path: '/app/setting', redirect: '/app/setting/user' },

    { path: '/app/master', redirect: '/app/master/jenis-proyek' },
    // {path: '/app/perizinan', redirect: '/app/perizinan'},
    {
      path: '/app/perizinan/detail-verifikasi-dokumen',
      redirect: '/app/perizinan',
    },
    {
      path: '/app/perizinan/detail-verifikasi-teknis',
      redirect: '/app/perizinan',
    },
    {
      path: '/documentation',
      redirect: '/documentation/getting-started/overview',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/lupa-password',
      name: 'Lupa Password',
      component: LupaPassword,
    },
    {
      path: '/privacy',
      name: 'ToS',
      component: TOS,
    },
    {
      path: '/verifikasi-email',
      name: 'VerifikasiUser',
      component: VerifikasiUser,
    },
    {
      path: '/extra/login',
      name: 'LoginExample',
      component: LoginExample,
    },
    {
      path: '*',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/documentation',
      name: 'Documentation',
      component: Documentation,
      children: [
        {
          path: 'getting-started/overview',
          name: 'Overview',
          component: DocOverviewPage,
        },
        {
          path: 'getting-started/licenses',
          name: 'Licenses',
          component: DocLicensesPage,
        },
        {
          path: 'getting-started/quick-start',
          name: 'QuickStart',
          component: DocQuickStartPage,
        },
        {
          path: 'components/alerts',
          name: 'Alerts',
          component: DocAlertsPage,
        },
        {
          path: 'components/badge',
          name: 'Badge',
          component: DocBadgePage,
        },
        {
          path: 'components/buttons',
          name: 'Buttons',
          component: DocButtonsPage,
        },
        {
          path: 'components/card',
          name: 'Card',
          component: DocCardPage,
        },
        {
          path: 'components/carousel',
          name: 'Carousel',
          component: DocCarouselPage,
        },
        {
          path: 'components/modal',
          name: 'Modal',
          component: DocModalPage,
        },
        {
          path: 'components/nav',
          name: 'Nav',
          component: DocNavPage,
        },
        {
          path: 'components/navbar',
          name: 'Navbar',
          component: DocNavbarPage,
        },
        {
          path: 'components/popovers',
          name: 'Popovers',
          component: DocPopoversPage,
        },
        {
          path: 'components/progress',
          name: 'Progress',
          component: DocProgressPage,
        },
        {
          path: 'components/tabs',
          name: 'Tabs',
          component: DocTabsPage,
        },
        {
          path: 'libs',
          name: 'Libs',
          component: DocLibsPage,
        },
        {
          path: 'pages',
          name: 'Pages',
          component: DocPagesPage,
        },
      ],
    },
    {
      path: '/app',
      name: 'Layout',
      component: Layout,
      beforeEnter: (to, from, next) => {
        let token = localStorage.getItem('token')
        isAuthenticated(token) ? next() : next({ path: '/login' })
      },
      children: [
        // main pages
        {
          path: 'dashboard',
          name: 'AnalyticsPage',
          component: AnalyticsPage,
        },
        {
          path: 'main/visits',
          name: 'VisitsPage',
          component: VisitsPage,
        },
        {
          path: 'main/widgets',
          name: 'WidgetsPage',
          component: WidgetsPage,
        },
        // user pages
        {
          path: 'setting/user',
          name: 'UserPage',
          component: UserPage,
        },
        {
          path: 'setting/tandatangan',
          name: 'TandatanganPage',
          component: TandatanganPage,
        },
        // role pages
        {
          path: 'setting/role',
          name: 'RolePage',
          component: RolePage,
        },
        // modus
        {
          path: 'master/jenis-proyek',
          name: 'JenisPage',
          component: JenisPage,
        },
        {
          path: 'master/jenis-permohonan',
          name: 'JenisPermohonanPage',
          component: JenisPermohonanPage,
        },
        {
          path: 'master/klasifikasi-pemohon',
          name: 'KlasifikasiPemohonPage',
          component: KlasifikasiPemohonPage,
        },
        {
          path: 'master/risiko',
          name: 'RisikoPage',
          component: RisikoPage,
        },

        {
          path: 'master/skala-usaha',
          name: 'SkalaPage',
          component: SkalaPage,
        },
        {
          path: 'master/kbli',
          name: 'KBLIPage',
          component: KBLIPage,
        },
        {
          path: 'master/dinas-pemda',
          name: 'DinasPemda',
          component: PEMDA,
        },
        {
          path: 'master/kementerian',
          name: 'Kementerian',
          component: Kementerian,
        },
        {
          path: 'master/kop-surat',
          name: 'KopSurat',
          component: KopSurat,
        },
        {
          path: 'master/capaian-target-pnbp',
          name: 'CapaianTargetPNBP',
          component: CapaianTargetPNBP,
        },
        {
          path: 'master/status-verifikasi',
          name: 'StatusPage',
          component: StatusPage,
        },
        {
          path: 'master/lokasi',
          name: 'LokasiPage',
          component: LokasiPage,
        },
        // Perizinan Berusaha
        {
          path: 'perizinan',
          name: 'PerizinanDokumenPage',
          component: PerizinanDokumenPage,
        },
        {
          path: 'perizinan/detail-perizinan/:id',
          name: 'PerizinanDetailPage',
          component: PerizinanDetailPage,
        },
        {
          path: 'perizinan/detail-verifikasi-dokumen/:id',
          name: 'PerizinanDokumenDetailPage',
          component: PerizinanDokumenDetailPage,
        },
        {
          path: 'perizinan/detail-verifikasi-teknis/:id',
          name: 'PerizinanTeknisDetailPage',
          component: PerizinanTeknisDetailPage,
        },
        {
          path: 'perizinan/ba/:id',
          name: 'PerizinanBADetailPage',
          component: PerizinanBADetailPage,
        },

        // Notifikasi Izin Lokasi
        {
          path: 'notifikasi-izin-lokasi',
          name: 'NotifikasiIzinLokasiDokumenPage',
          component: IzinLokasiDokumenPage,
        },
        {
          path: 'notifikasi-izin-lokasi/detail-perizinan/:id',
          name: 'NotifikasiIzinLokasiDetailPage',
          component: IzinLokasiDetailPage,
        },
        {
          path: 'notifikasi-izin-lokasi/detail-verifikasi-dokumen/:id',
          name: 'IzinLokasiDokumenDetailPage',
          component: IzinLokasiDokumenDetailPage,
        },
        {
          path: 'notifikasi-izin-lokasi/detail-verifikasi-teknis/:id',
          name: 'IzinLokasiTeknisDetailPage',
          component: IzinLokasiTeknisDetailPage,
        },
        {
          path: 'notifikasi-izin-lokasi/ba/:id',
          name: 'IzinLokasiBADetailPage',
          component: IzinLokasiBADetailPage,
        },

        // Penambahan KBLI
        {
          path: 'penambahan-kbli',
          name: 'penambahan-kbli-DokumenPage',
          component: PenambahanKBLIDokumenPage,
        },
        {
          path: 'penambahan-kbli/detail-perizinan/:id',
          name: 'penambahan-kbli-DetailPage',
          component: PenambahanKBLIDetailPage,
        },
        {
          path: 'penambahan-kbli/detail-verifikasi-dokumen/:id',
          name: 'penambahan-kbli-DokumenDetailPage',
          component: PenambahanKBLIDokumenDetailPage,
        },
        {
          path: 'penambahan-kbli/detail-verifikasi-teknis/:id',
          name: 'penambahan-kbli-TeknisDetailPage',
          component: PenambahanKBLITeknisDetailPage,
        },
        {
          path: 'penambahan-kbli/ba/:id',
          name: 'penambahan-kbli-BADetailPage',
          component: PenambahanKBLIBADetailPage,
        },

        //Non berusaha
        {
          path: 'nonberusaha/pemerintah',
          name: 'nonberusahaPemerintah',
          component: NonberusahaPemerintah,
        },
        {
          path: 'nonberusaha/form',
          name: 'FormPermohonanNonBerusaha',
          component: FormPermohonanNonberusaha,
        },
        {
          path: 'nonberusaha/swasta',
          name: 'nonberusahaSwasta',
          component: NonberusahaSwasta,
        },
        {
          path: 'nonberusaha/detail-perizinan/:id',
          name: 'PerizinanNonberusaha',
          component: PerizinanNonberusaha,
        },

        {
          path: 'nonberusaha/detail-verifikasi-teknis/:id',
          name: 'PerizinanTeknisNonBerusahaDetailPage',
          component: PentekNonberusaha,
        },

        {
          path: 'nonberusaha/detail-verifikasi-dokumen/:id',
          name: 'PerizinanDokumenNonBerusahaDetailPage',
          component: VerdokNonBerusaha,
        },
        {
          path: 'nonberusaha/ba/:id',
          name: 'BANonBerusaha',
          component: BANonBerusaha,
        },

        //UMK
        {
          path: 'perizinan-umk',
          name: 'PerizinanUMK',
          component: PerizinanUMK,
        },
        {
          path: 'perizinan-umk/detail-perizinan/:id',
          name: 'PerizinanDetailUMK',
          component: PerizinanDetailUMK,
        },

        //pemohon

        {
          path: 'permohonan/berusaha',
          name: 'PermohonanBerusaha',
          component: PermohonanBerusaha,
        },
        {
          path: 'permohonan/form-berusaha',
          name: 'FormBerusaha',
          component: FormPermohonanBerusaha,
        },

        {
          path: 'permohonan/non-berusaha/pemerintah',
          name: 'PermohonanPemerintah',
          component: PermohonanPemerintah,
        },
        {
          path: 'permohonan/form',
          name: 'FormPermohonan',
          component: FormPermohonan,
        },
        {
          path: 'permohonan/detail/:id',
          name: 'Detail-Permohonan',
          component: DetailPermohonan,
        },

        {
          path: 'permohonan/non-berusaha/swasta',
          name: 'PermohonanSwasta',
          component: PermohonanSwasta,
        },

        //UMK
        {
          path: 'permohonan/form-umk',
          name: 'FormPermohonanUMK',
          component: FormPermohonanUMK,
        },

        {
          path: 'permohonan/umk',
          name: 'PermohonanUMK',
          component: PermohonanUMK,
        },
        {
          path: 'profil',
          name: 'ProfilePage',
          component: ProfilePage,
        },

        // laporan tahunan
        {
          path: 'dashboard-pengendalian',
          name: 'DashboardPengendalian',
          component: DashboardPengendalian,
        },
        {
          path: 'laporan-tahunan',
          name: 'LaporanTahunan',
          component: LaporanTahunanPage,
        },
        // {
        //   path: 'laporan-tahunan/form',
        //   name: 'FormLaporanTahunan',
        //   component: formLaporanTahunanPage,
        // },
        // {
        //   path: 'laporan-tahunan/tinjau',
        //   name: 'TinjauLaporanTahunanPemohon',
        //   component: formLaporanTahunanPage,
        // },
        {
          path: 'penilaian-laporan-tahunan',
          name: 'PenilaianLaporanTahunan',
          component: PenilaianLaporanTahunanPage,
        },
        {
          path: 'penilaian-laporan-tahunan/verifikasi',
          name: 'VerifikasiLaporan',
          component: formVerifikasiLaporanPage,
        },
        {
          path: 'penilaian-laporan-tahunan/tinjau',
          name: 'TinjauLaporanTahunan',
          component: formLaporanTahunanPage,
        },

        // pemutakhiran
        {
          path: 'pemutakhiran',
          name: 'Pemutakhiran',
          component: Pemutakhiran,
        },
        {
          path: 'pemutakhiran/form',
          name: 'PemutakhiranForm',
          component: PemutakhiranForm,
        },

        // early warning
        {
          path: 'early-warning',
          name: 'EarlyWarning',
          redirect: '/early-warning/berusaha',
        },
        {
          path: 'early-warning/berusaha',
          name: 'EarlyWarningBerusaha',
          component: EarlyWarningBerusaha,
        },
        {
          path: 'early-warning/pemerintah',
          name: 'EarlyWarningPemerintah',
          component: EarlyWarningPemerintah,
        },
        {
          path: 'early-warning/swasta',
          name: 'EarlyWarningSwasta',
          component: EarlyWarningSwasta,
        },

        // habis masa berlaku
        {
          path: 'habis-masa-berlaku',
          name: 'HabisMasaBerlaku',
          component: HabisMasaBerlaku,
        },
        {
          path: 'habis-masa-berlaku/pemutakhiran',
          name: 'HabisMasaBerlakuPemutakhiran',
          component: HabisMasaBerlakuPemutakhiran,
        },

        // perubahan
        {
          path: 'perubahan',
          name: 'Perubahan',
          component: Perubahan,
        },
        {
          path: 'perubahan/verifikasi',
          name: 'PerubahanVerifikasi',
          component: PerubahanVerifikasi,
        },
        {
          path: 'perubahan/pemutakhiran',
          name: 'PerubahanPemutakhiran',
          component: PerubahanPemutakhiran,
        },

        // pembatalan
        {
          path: 'pembatalan',
          name: 'Pembatalan',
          component: Pembatalan,
        },
        {
          path: 'pembatalan/verifikasi',
          name: 'PembatalanVerifikasi',
          component: PembatalanVerifikasi,
        },
        {
          path: 'pembatalan/pemutakhiran',
          name: 'PembatalanPemutakhiran',
          component: PembatalanPemutakhiran,
        },

        // pencabutan
        {
          path: 'pencabutan',
          name: 'Pencabutan',
          component: Pencabutan,
        },
        {
          path: 'pencabutan/pemutakhiran',
          name: 'PencabutanPemutakhiran',
          component: PencabutanPemutakhiran,
        },

        // panduan
        {
          path: 'panduan',
          name: 'Panduan',
          component: PanduanPage,
        },
        // ______________WEB_PROFILE___________
        {
          path: '/app/web/profile',
          name: 'Profile',
          component: Profile,
        },
        {
          path: '/app/web/slider',
          name: 'Slider',
          component: Slider,
        },
        {
          path: '/app/web/about',
          name: 'About',
          component: About,
        },
        {
          path: '/app/web/approval',
          name: 'Perizian',
          component: Approval,
        },
        {
          path: '/app/web/announcement',
          name: 'Pengumuman',
          component: Announcement,
        },
        {
          path: '/app/web/announcement/detail/',
          name: 'Tambah Pengumuman',
          component: AnnouncementDetail,
        },
        {
          path: '/app/web/announcement/detail/:id',
          name: 'Edit Pengumuman',
          component: AnnouncementDetail,
        },
        {
          path: '/app/web/report',
          name: 'Report',
          component: Report,
        },
        {
          path: '/app/web/gallery',
          name: 'Galeri',
          component: Gallery,
        },
        {
          path: '/app/web/faq',
          name: 'FAQ',
          component: faq,
        },
        // _____________END_WEB_PROFILE___________
        // {
        //   path: 'perizinan/verifikasidokumen',
        //   name: 'PerizinanDokumenPage',
        //   component: PerizinanDokumenPage,
        // },
        // {
        //   path: 'perizinan/verifikasidokumen/tambah',
        //   name: 'PerizinanDokumenTambahPage',
        //   component: PerizinanDokumenTambahPage,
        // },
        // {
        //   path: 'perizinan/verifikasidokumen/detail/:id',
        //   name: 'PerizinanDokumenDetailPage',
        //   component: PerizinanDokumenDetailPage,
        // },
        // {
        //   path: 'perizinan/verifikasiteknis',
        //   name: 'PerizinanTeknisPage',
        //   component: PerizinanTeknisPage,
        // },
        // {
        //   path: 'perizinan/verifikasiteknis/tambah',
        //   name: 'PerizinanTeknisTambahPage',
        //   component: PerizinanTeknisTambahPage,
        // },
        // {
        //   path: 'perizinan/verifikasiteknis/detail/:id',
        //   name: 'PerizinanTeknisDetailPage',
        //   component: PerizinanTeknisDetailPage,
        // },
        // {
        //   path: 'perizinan/verifikasiteknis/ba/:id',
        //   name: 'PerizinanBADetailPage',
        //   component: PerizinanBADetailPage,
        // },
        // package page
        {
          path: 'package',
          name: 'PackagePage',
          component: PackagePage,
        },
        // Chat page
        {
          path: 'chat',
          name: 'ChatPage',
          component: ChatPage,
        },
        // profile page

        // email page
        {
          path: 'email',
          name: 'EmailPage',
          component: EmailPage,
        },
        // ecommerce pages
        {
          path: 'ecommerce/management',
          name: 'ProductsManagement',
          component: ProductsManagement,
        },
        {
          path: 'ecommerce/management/:id',
          name: 'ProductEdit',
          component: ProductEdit,
        },
        {
          path: 'ecommerce/management/create',
          name: 'ProductCreate',
          component: ProductEdit,
        },
        {
          path: 'ecommerce/products',
          name: 'ProductsPage',
          component: ProductsPage,
        },
        {
          path: 'ecommerce/product',
          name: 'ProductPage',
          component: ProductPage,
        },
        {
          path: 'ecommerce/product/:id',
          name: 'DefiniteProductPage',
          component: ProductPage,
        },
        // core pages
        {
          path: 'core/typography',
          name: 'TypographyPage',
          component: TypographyPage,
        },
        {
          path: 'core/colors',
          name: 'ColorsPage',
          component: ColorsPage,
        },
        {
          path: 'core/grid',
          name: 'CoreGridPage',
          component: CoreGridPage,
        },
        // ui pages
        {
          path: 'ui/alerts',
          name: 'AlertsPage',
          component: AlertsPage,
        },
        {
          path: 'ui/badge',
          name: 'BadgePage',
          component: BadgePage,
        },
        {
          path: 'ui/buttons',
          name: 'ButtonsPage',
          component: ButtonsPage,
        },
        {
          path: 'ui/card',
          name: 'CardPage',
          component: CardPage,
        },
        {
          path: 'ui/carousel',
          name: 'CarouselPage',
          component: CarouselPage,
        },
        {
          path: 'ui/jumbotron',
          name: 'JumbotronPage',
          component: JumbotronPage,
        },
        {
          path: 'ui/icons',
          name: 'IconsPage',
          component: IconsPage,
        },
        {
          path: 'ui/list-groups',
          name: 'ListGroupsPage',
          component: ListGroupsPage,
        },
        {
          path: 'ui/modal',
          name: 'ModalPage',
          component: ModalPage,
        },
        {
          path: 'ui/nav',
          name: 'NavPage',
          component: NavPage,
        },
        {
          path: 'ui/navbar',
          name: 'NavbarPage',
          component: NavbarPage,
        },
        {
          path: 'ui/notifications',
          name: 'NotificationsPage',
          component: NotificationsPage,
        },
        {
          path: 'ui/popovers',
          name: 'PopoversPage',
          component: PopoversPage,
        },
        {
          path: 'ui/progress',
          name: 'ProgressPage',
          component: ProgressPage,
        },
        {
          path: 'ui/tabs',
          name: 'TabsPage',
          component: TabsPage,
        },
        // forms
        {
          path: 'forms/elements',
          name: 'FormElementsPage',
          component: FormElementsPage,
        },
        {
          path: 'forms/validation',
          name: 'FormValidationPage',
          component: FormValidationPage,
        },
        {
          path: 'forms/wizard',
          name: 'FormWizardPage',
          component: FormWizardPage,
        },
        // Charts
        {
          path: 'charts/overview',
          name: 'ChartsPage',
          component: ChartsPage,
        },
        {
          path: 'charts/apex',
          name: 'ApexPage',
          component: ApexPage,
        },
        {
          path: 'charts/echarts',
          name: 'EchartsPage',
          component: EchartsPage,
        },
        {
          path: 'charts/highcharts',
          name: 'HighchartsPage',
          component: HighchartsPage,
        },
        // grid page
        {
          path: 'grid',
          name: 'GridPage',
          component: GridPagePage,
        },
        // tables pages
        {
          path: 'tables/basic',
          name: 'TablesBasicPage',
          component: TablesBasicPage,
        },
        {
          path: 'tables/dynamic',
          name: 'TablesDynamicPage',
          component: TablesDynamicPage,
        },
        // maps pages
        {
          path: 'maps/google',
          name: 'GoogleMapPage',
          component: GoogleMapPage,
        },
        {
          path: 'maps/amcharts',
          name: 'AmchartsMapPage',
          component: AmchartsMapPage,
        },
        // extra pages
        {
          path: 'extra/calendar',
          name: 'CalendarPage',
          component: CalendarPage,
        },
        {
          path: 'extra/invoice',
          name: 'InvoicePage',
          component: InvoicePage,
        },
        {
          path: 'extra/search',
          name: 'SearchPage',
          component: SearchPage,
        },
        {
          path: 'extra/time-line',
          name: 'TimelinePage',
          component: TimelinePage,
        },
        {
          path: 'extra/gallery',
          name: 'GalleryPage',
          component: GalleryPage,
        },
      ],
    },
  ],
})
